var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mohu"},[_c('p',{staticClass:"ysw"},[_vm._v("以下为您显示“"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.homonymName))]),_vm._v("”的搜索结果。仍搜索： "),_c('a',{staticStyle:{"text-decoration":"underline","color":"blue"},attrs:{"href":_vm.linkUrl}},[_vm._v(_vm._s(_vm.$global.q))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }